import { CONFIG } from 'src/config';

export const EXTERNAL_URLS = {
  WEBAPP_HOME: CONFIG.WebappDomain + '/',
};
